import {UmpireSquad} from '../umpire-squad';
import {UmpireSquadPlayer} from '../umpire-squad-player';
import {UmpireImage} from '../umpire-image';

export interface UmpireRating {
  average_rating: string | undefined;

  first_name: string | undefined;

  id: string | undefined;

  image: Partial<UmpireImage> | undefined;

  last_name: string | undefined;

  number: string | undefined;

  player: UmpireSquadPlayer | undefined;

  position: string | undefined;

  squad: UmpireSquad | undefined;

  relationshipNames: string[];
}
